<template>
  <div>
    <h3>Verify Bank Account</h3>
    <section>
      <div class="form-inline">
        <label>Deposit #1:</label>
        <div>
          <input type="text" placeholder="Deposit #1" v-model="editDeposit1" />
        </div>
      </div>
      <div class="form-inline">
        <label>Deposit #2:</label>
        <div>
          <input type="text" placeholder="Deposit #2" v-model="editDeposit2" />
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
        >Verify Bank Accoun</spinnerButton>
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading"],
  components: {
    spinnerButton
  },
  data() {
    return {
      editDeposit1: null,
      editDeposit2: null
    };
  },
  created: function() {
    this.initData();
  },
  methods: {
    initData: function() {
      this.editDeposit1 = null;
      this.editDeposit2 = null;
    },
    buttonClick: function() {
      this.$emit("buttonClick", this.editDeposit1, this.editDeposit2);
    }
  }
};
</script>